import { Link } from "react-router-dom";
import { useDispatch } from 'react-redux';
import { setFilter } from "../../redux/features/filter/filterSlice";


export default function Sidebar() {
    const dispatch = useDispatch();
    const filterHandler = (value) => {
        dispatch(setFilter(value));
    }
    return (
        <div className="sidebar">
            <nav>
                <ul className="space-y-4">
                    <li>
                        <Link onClick={() => filterHandler("")} to="/" className="main-menu menu-active" id="lws-alljobs-menu">
                            <i className="fa-solid fa-briefcase"></i>
                            <span> All Available Jobs</span>
                        </Link>
                        <ul className="space-y-6 lg:space-y-2 ">
                            <li>
                                <Link onClick={() => filterHandler("Internship")} className="sub-menu" to="/" id="lws-internship-menu">
                                    <i className="fa-solid fa-stop !text-[#FF5757]"></i>{" "}
                                    Internship
                                </Link>
                            </li>
                            <li>
                                <Link onClick={() => filterHandler("Full Time")} className="sub-menu" to="/" id="lws-fulltime-menu">
                                    <i className="fa-solid fa-stop !text-[#FF8A00]"></i>{" "}
                                    Full Time
                                </Link>
                            </li>
                            <li>
                                <Link onClick={() => filterHandler("Remote")} className="sub-menu" to="/" id="lws-remote-menu">
                                    <i className="fa-solid fa-stop !text-[#56E5C4]"></i>{" "}
                                    Remote
                                </Link>
                            </li>
                        </ul>
                    </li>
                    <li>
                        <Link to="/addnew" className="main-menu" id="lws-addJob-menu">
                            <i className="fa-solid fa-file-circle-plus"></i>
                            <span>Add NewJob</span>
                        </Link>
                    </li>
                </ul>
            </nav>
        </div>)
};